/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class LoadingIndicatorConstants {
}
LoadingIndicatorConstants.GLOBAL_KEY = 'window.sirius.shared.loadingIndicator';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZGluZy1pbmRpY2F0b3IuY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NoYXJlZC9sb2FkaW5nLWluZGljYXRvcnMvbG9hZGluZy1pbmRpY2F0b3IuY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLHlCQUF5Qjs7QUFDWCxvQ0FBVSxHQUFHLHVDQUF1QyxDQUFDIn0=